export const apiUrl = process.env.NODE_ENV !== 'production' ? "https://cutomer-portal-service-test.azurewebsites.net" : "https://customer-portal-service.azurewebsites.net/api";

//https://localhost:44333/api
//https://cutomer-portal-service-test.azurewebsites.net